"use client";

import {
  Flex,
  Heading,
  Spinner,
} from "@chakra-ui/react";
// import { ButtonMenu } from "./ButtonMenu";

export const Header = ({ label, isLoading }) => {
  // return (
  //   <Flex h={"1.5rem"}>
  //     {isLoading ? (
  //       <Spinner size="md" color="colorPalette.600" colorPalette={"green"} />
  //     ) : null}
  //   </Flex>
  // );

  // return null;

  return (
    <Flex
      w={"100%"}
      overflow={"hidden"}
      alignItems={"center"}
      gap={"1rem"}
      mb={"1rem"}
      justify={"space-between"}
      // pr={"2rem"}
      wrap={'wrap'}
    >
      <Flex alignItems={"center"} gap={"1rem"}>
        <Heading  color={'text'} size="4xl" mb="2.5" lineClamp={1}>
          {label || ""}
        </Heading>
        {isLoading ? (
          <Spinner size="md" color="spinner" colorPalette={"spinner"} />
        ) : null}
      </Flex>
      <Flex />
      {/* <ButtonMenu /> */}
    </Flex>
  );
};

// <Flex alignItems={"center"}>
//   <PopOverComp
//     TriggerComp={
//       <Flex>
//         <Avatar.Root size={"xl"}>
//           <Avatar.Fallback name="Parmar Vishal" />
//           <Avatar.Image src={imgurl} />
//           {/* <Avatar.Context>
//     </Avatar.Context> */}
//         </Avatar.Root>
//       </Flex>
//     }
//     Body={
//       <Popover.Body>
//         <Flex overflow={"hidden"} gap={'0.5rem'} direction={'column'}>
//           {/* <Popover.Title fontWeight="medium">Profile</Popover.Title> */}
//           <Text>Parmar Vishal</Text>
//           <Button variant={"ghost"} w={'10rem'}>Logout</Button>
//         </Flex>
//       </Popover.Body>
//     }
//   />
// </Flex>
